import { Injectable } from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { filter } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ScrollToTopService {

  constructor(private router: Router) { }

  /**
   * Configura el servicio para que detecte los eventos de navegación
   * y realice el scroll al principio de la página
   */
  setupScrollToTop(): void {
    this.router.events.pipe(
      // Filtra solo eventos de tipo NavigationEnd (cuando se completa la navegación)
      filter(event => event instanceof NavigationEnd)
    ).subscribe(() => {
      // Asegura que la página comience desde arriba
      window.scrollTo(0, 0);
    });
  }
} 